//我的api
import request from "@/utils/request";

export const url = {
  GetBillInfo: "/api/OrderSign/GetBillInfo", //通过订单Id 查询账单信息
  GetRegisterInfo: "/api/OrderSign/GetRegisterInfo", //通过订单Id 查询登记单信息
  GetImage: "/api/OrderSign/GetImage", //获取图片
  UploadImage: "/api/OrderSign/UploadImage", //上传图片
};

export function getBillInfo(data) {
  return request({
    url: url.GetBillInfo,
    method: "post",
    data: data,
  });
}
export function getRegisterInfo(data) {
  return request({
    url: url.GetRegisterInfo,
    method: "post",
    data: data,
  });
}
export function getImage(data) {
  return request({
    url: url.GetImage,
    method: "post",
    data: data,
  });
}
export function uploadImage(data) {
  return request({
    url: url.UploadImage,
    method: "post",
    data: data,
  });
}
